import styled from "@emotion/styled";
import { FormattedDate } from "./FormattedDate";

const ChipRoot = styled.span`
  display: inline-flex;
  align-items: stretch;
  border-radius: 0.375rem;
  border: 1px solid ${(p) => p.theme.text.colors.brand};
  overflow: hidden;
  font-size: ${(p) => p.theme.text.fontSizes.s};
  font-weight: 600;
  line-height: 1.4;
`;

const ChipLabel = styled.span`
  padding: 0.125rem 0.375rem;
  background-color: ${(p) => p.theme.colors.background5};
  color: ${(p) => p.theme.text.colors.brand};
`;

const ChipValue = styled.span`
  padding: 0.125rem 0.375rem;
  background-color: ${(p) => p.theme.text.colors.brand};
  color: ${(p) => p.theme.colors.background};
  text-transform: capitalize;
`;

type LeadChipText = { label?: string; value: string; type?: never };
type LeadChipDate = { label?: string; value: string | Date; type: "date" };

export type LeadChipItem = LeadChipText | LeadChipDate;

export const LeadChip = ({ label, value, type }: LeadChipItem) => (
  <ChipRoot>
    {label && <ChipLabel>{label}</ChipLabel>}
    <ChipValue>
      {type === "date" ? <FormattedDate value={value} /> : value.toLowerCase()}
    </ChipValue>
  </ChipRoot>
);
